import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-2xl font-bold text-primary-500 tracking-tight">
              韩漫
            </span>
            <span className="font-heading text-lg text-foreground-700 hidden sm:inline">
              网站
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                location.pathname === '/' ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                分类 <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 rounded-lg border border-background-200/60 py-2 min-w-[160px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap"
                    >
                      <span className={`w-2 h-2 rounded-full ${cat.color}`}></span>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                location.pathname === '/about' ? 'text-primary-500' : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className="w-9 h-9 flex items-center justify-center text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-lg"></i>
            </button>

            <Link
              to="/category/romance"
              className="hidden md:inline-flex items-center gap-1.5 bg-primary-500 text-background-50 text-sm font-medium px-5 py-2 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读 <i className="ri-arrow-right-line text-sm"></i>
            </Link>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="lg:hidden w-9 h-9 flex items-center justify-center text-foreground-600 cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {searchOpen && (
          <div className="pb-4 px-1">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索漫画名称、作者..."
                className="w-full pl-10 pr-4 py-2.5 text-sm bg-background-100 border border-background-200/60 rounded-lg text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
              />
            </div>
          </div>
        )}
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-3 py-2.5 rounded-lg text-sm font-medium ${
                location.pathname === '/'
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100"
              >
                <span className={`w-2 h-2 rounded-full ${cat.color}`}></span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2.5 rounded-lg text-sm font-medium ${
                location.pathname === '/about'
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}